/* eslint-disable max-len */
import React from 'react'
import { motion } from "framer-motion";
import { useSelector } from 'react-redux';


const AnimatedList = ({ child, keyItem ,id,rowStatus,handleClick,cursorpointer,removeHover}) => {
    
    const selectedId=useSelector((state)=>state.MultiSelectSlice.selectedRows.selectedIds)
    const selectedRows=selectedId.map((item)=>item.id)
    return (
        <motion.tr
            key={keyItem}
            id= "list-items"
            onClick={(e)=>{
                if(handleClick){
                    handleClick(e)
                }
            }}
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 0 }}
            exit={{ opacity: 0, x: 0}}   
            transition={{ duration: 0.15 }}
            className={`${selectedRows.includes(id)?"bg-[#F8EEF1]":"bg-[#FFFFFF]"} hover:bg-[#F8EEF1] rounded-[2px] ${removeHover ? "" : "hover:bg-[#F8EEF1]"} table-tr ${cursorpointer ? 'cursor-pointer' : ''}`}
        >
            {child}
        </motion.tr>
    );
}

export default AnimatedList;